/* Coffee Lab — entry point. Mounts <App /> to #root and registers the SW. */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.jsx';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Service worker — cache-first for app shell, network-first for fonts.
// Only registers in production builds; dev mode would cache stale HMR modules otherwise.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      // Non-fatal — app still works, just won't be installable / offline-capable.
      console.warn('SW registration failed:', err);
    });
  });
}
